<template>
    <KLineItemsList
        v-if="variant === 'default'"
        v-bind="{ ...props, ...attrs }"
        @edit="emit('edit', $event)"
    >
        <template
            v-if="slots.label"
            #label="slotProps"
        >
            <slot
                name="label"
                v-bind="slotProps"
            />
        </template>
        <template
            v-if="slots.value"
            #value="slotProps"
        >
            <slot
                name="value"
                v-bind="slotProps"
            />
        </template>
    </KLineItemsList>
    <KCard
        v-else
        v-bind="attrs"
        :class="element('card')"
        variant="outline"
        padding="md"
    >
        <header
            v-if="heading || supporting"
            :class="element('header')"
        >
            <h3
                v-if="heading"
                :class="element('heading')"
            >
                {{ heading }}
            </h3>
            <p
                v-if="supporting"
                :class="element('supporting')"
            >
                {{ supporting }}
            </p>
        </header>
        <KLineItemsList
            v-bind="props"
            @edit="emit('edit', $event)"
        >
            <template
                v-if="slots.label"
                #label="slotProps"
            >
                <slot
                    name="label"
                    v-bind="slotProps"
                />
            </template>
            <template
                v-if="slots.value"
                #value="slotProps"
            >
                <slot
                    name="value"
                    v-bind="slotProps"
                />
            </template>
        </KLineItemsList>
    </KCard>
</template>

<script setup lang="ts">
import type { KLineItemEditEvent, KLineItemsProps, KLineItemsSlots } from './types'
import useBem from '@yeeroen/use-bem'
import { useAttrs, useSlots } from 'vue'
import KCard from '../card/k-card.vue'
import KLineItemsList from './k-line-items-list.vue'

defineOptions({ name: 'KLineItems', inheritAttrs: false })

const props = withDefaults(defineProps<KLineItemsProps>(), {
    items: () => [],
    trailing: undefined,
    mutedLabels: false,
    variant: 'default',
    heading: undefined,
    supporting: undefined,
    editText: 'Edit',
})

const emit = defineEmits<{
    edit: [event: KLineItemEditEvent]
}>()

defineSlots<KLineItemsSlots>()

const attrs = useAttrs()
const slots = useSlots()
const { element } = useBem('k-line-items')
</script>

<style lang="scss">
@use './k-line-items.scss';
</style>
